import { T_ADULT_WELCOME_POPUP_PAGE_CONSTANTS } from './TYPES'

const FR_ADULT_WELCOME_POPUP_PAGE_CONSTANTS: T_ADULT_WELCOME_POPUP_PAGE_CONSTANTS =
  {
    TITLE: 'Bienvenue sur GriffyReads !',
    KICKER: 'Avant que votre enfant puisse commencer à lire...',
    BODY: "GriffyReads est conçu pour les enfants. Pour accéder aux quiz, aux défis de lecture et aux événements, votre enfant a besoin de son propre compte, que vous pouvez créer en moins d'une minute.",
    STEP_1_TITLE: '1. Créer un compte enfant',
    STEP_1_BODY:
      'Ajoutez le profil de votre enfant en quelques étapes simples.',
    STEP_2_TITLE: "2. L'enfant se connecte",
    STEP_2_BODY:
      "L'enfant utilise son propre compte pour entrer dans GriffyReads et répondre aux quiz.",
    STEP_3_TITLE: '3. Lire, jouer et grandir',
    STEP_3_BODY:
      'Ils peuvent répondre à des quiz, gagner des points et participer à des défis de lecture et aux événements.',
    PRIMARY_CTA: 'Créer un compte enfant',
    SECONDARY_CTA: 'Peut-être plus tard',
    FOOTER:
      'Les comptes adultes sont gratuits. Les enfants ne peuvent pas créer de compte eux-mêmes.'
  }

export default FR_ADULT_WELCOME_POPUP_PAGE_CONSTANTS
